// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  getFulfillmentCycleTimeReport,
  serializeFulfillmentCycleTimeReportFilter,
} from '@/fulfillment/api/get-fulfillment-analytics';
import { fulfillmentCycleTimeReportQueryKey } from '@/fulfillment/query-keys';
import type { CycleTimeReportFilter } from '@/report/api/types';
import { ONE_MINUTE_MS } from '@/utilities/time-constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

interface UseFulfillmentCycleTimeReportOptions {
  filter?: CycleTimeReportFilter;
}

export function useFulfillmentCycleTimeReport(
  options: UseFulfillmentCycleTimeReportOptions = {}
) {
  const filterString = serializeFulfillmentCycleTimeReportFilter(
    options.filter
  );
  const { data, ...query } = useQuery({
    queryKey: fulfillmentCycleTimeReportQueryKey(filterString),
    queryFn: () => getFulfillmentCycleTimeReport(options.filter),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    staleTime: ONE_MINUTE_MS,
    throwOnError: true,
  });

  return { report: data?.data ?? null, ...query };
}
